<template>
  <b-container v-if="!loading" class="d-flex flex-column h-100" fluid>
    <b-card body-class="py-0 px-0" class="border-0 mb-0">
      <b-nav class="nav-base">
        <b-nav-item :to="{ name: 'apiNotDownloaded' }">
          <b-icon class="mr-1" icon="calendar2-x" />
          Nestiahnuté dáta
        </b-nav-item>
      </b-nav>
    </b-card>
    <b-row class="flex-grow-1" style="min-height: 1px">
      <transition name="fadeDownShort" mode="out-in">
        <router-view :key="$route.params.id" />
      </transition>
    </b-row>
  </b-container>
</template>
<script>
export default {
  data() {
    return {
      loading: false,
    }
  },
}
</script>
